"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationContainer = exports.DownloadLink = exports.FilesValidationText = exports.LoadingText = exports.LoadingContainer = exports.ErrorDetailsText = exports.ErrorDetailsContainer = exports.ErrorAlert = exports.SuccessAlert = exports.StatusContainer = exports.ActionsContainer = exports.DetailText = exports.StatusText = exports.ProgressContainer = exports.ModalContent = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const material_1 = require("@mui/material");
exports.ModalContent = (0, styled_components_1.default)(material_1.Box) `
  min-height: 240px;
  display: flex;
  flex-direction: column;
`;
exports.ProgressContainer = (0, styled_components_1.default)(material_1.Box) `
  margin: 12px 0;
  display: flex;
`;
exports.StatusText = (0, styled_components_1.default)(material_1.Typography) `
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 8px;
`;
exports.DetailText = (0, styled_components_1.default)(material_1.Typography) `
  font-weight: 700;
`;
exports.ActionsContainer = (0, styled_components_1.default)(material_1.Box) `
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
`;
exports.StatusContainer = styled_components_1.default.div `
  display: flex;
  gap: 16px;
  align-items: center;
`;
exports.SuccessAlert = styled_components_1.default.div `
  margin: 16px 0;
`;
exports.ErrorAlert = styled_components_1.default.div `
  margin: 16px 0;
`;
exports.ErrorDetailsContainer = (0, styled_components_1.default)(material_1.Box) `
  height: 100%;
`;
exports.ErrorDetailsText = (0, styled_components_1.default)(material_1.Typography) `
  color: ${({ theme }) => theme.palette.error.main};
  font-weight: 700;
`;
exports.LoadingContainer = (0, styled_components_1.default)(material_1.Box) `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
`;
exports.LoadingText = (0, styled_components_1.default)(material_1.Typography) `
  margin-top: 16px;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 14px;
`;
exports.FilesValidationText = (0, styled_components_1.default)(material_1.Typography)(({ theme: { palette } }) => (0, styled_components_1.css) `
    color: ${palette.warning.main};
    font-weight: 700;
    font-size: 12px;
  `);
exports.DownloadLink = styled_components_1.default.a(({ theme: { palette } }) => (0, styled_components_1.css) `
    font-size: 12px;
    color: ${palette.warning.main};
    font-weight: 700;
    margin-left: 4px;
  `);
exports.ValidationContainer = styled_components_1.default.div `
  display: flex;
`;
